import routerOptions0 from "/src/app/router.options.js";
import routerOptions1 from "/src/node_modules/.pnpm/nuxt@3.8.1_@parcel+watcher@2.5.6_@types+node@18.19.130_encoding@0.1.13_eslint@9.39.4_jiti@2.6_uied467glhvx4rithb4pd4mnvu/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}